var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-outline-primary btn-sm pull-right mr-2"},[_vm._v(_vm._s(_vm.$t('global.Export')))])}
var staticRenderFns = []

export { render, staticRenderFns }